import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import SEO from './components/SEO';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Destinations from './components/Destinations';
import TravelCalculator from './components/TravelCalculator';
import PackingGenerator from './components/PackingGenerator';
import CountryDetail from './components/CountryDetail';
import AffiliateSection from './components/AffiliateSection';
import LoungesSection from './components/LoungesSection';
import BlogSection from './components/BlogSection';
import BlogDetail from './components/BlogDetail';
import AboutUs from './components/AboutUs';
import Impressum from './components/Impressum';

function HomePage() {
  return (
    <>
      <SEO 
        title="Budget Reisen & Reisetipps für über 20 Länder"
        description="Entdecke preiswerte Reiseziele weltweit! Just Travel bietet dir Budget-Reisetipps, Destination Guides, Packlisten und Spartipps für günstiges Reisen. Von Thailand bis Deutschland - spare Geld ohne auf Abenteuer zu verzichten!"
        keywords="budget reisen, günstig reisen, reisetipps, backpacking, sparfüchse reisen, preiswerte reiseziele, reiseblog, weltreise günstig, travel blog deutsch, reiseführer"
        url="https://www.just-travels.com/"
      />
      <Hero />
      <Destinations />
      <TravelCalculator />
      <PackingGenerator />
      <BlogSection />
      <AffiliateSection />
      <LoungesSection />
      <AboutUs />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <div className="App">
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/destination/:id" element={<CountryDetail />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              <Route path="/impressum" element={<Impressum />} />
            </Routes>
            <Footer />
          </div>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
